import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { acceptHallBook, fetchHallBookById, refundHallBook, refuseHallBook } from '../../features/home/bookingSlice';
import { AppDispatch, RootState } from '../../store';
import { CiLocationOn } from 'react-icons/ci';
import { FaStar, FaCalendarAlt, FaBed } from 'react-icons/fa';
import { GrStatusUnknown } from 'react-icons/gr';
import { IoPricetagsOutline } from 'react-icons/io5';
import { MdOutlineNumbers, MdOutlinePayments } from 'react-icons/md';
import { getStatusClass, formatDateRange } from '../../utils/data';
import ConfirmDeleteModal from './models/ConfirmDeleteModal';
import ConfirmModal from './models/ConfirmModal';

const AdminHallBookDetails = () => {
    const { bookId } = useParams();
    const { t, i18n } = useTranslation();
    const [confirmModalOpen, setConfirmModalOpen] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [selectedBookId, setSelectedBookId] = useState<number | null>(null)
    const dispatch = useDispatch<AppDispatch>()
    const { booking } = useSelector((state: RootState) => state.bookingSlice)
    const isHotel = booking?.place?.subCategory.id === 1;

    const handleConfirm = async () => {
        if (selectedBookId !== null) {
            await dispatch(acceptHallBook(selectedBookId));
            setSelectedBookId(null);
            dispatch(fetchHallBookById(Number(bookId)))
        }
    };
    const handleRefuse = async () => {
        if (selectedBookId !== null) {
            await dispatch(refuseHallBook(selectedBookId));
            setSelectedBookId(null);
            dispatch(fetchHallBookById(Number(bookId)))
        }

    };
    const confirm = (bookId: number) => {
        setSelectedBookId(bookId)
        setConfirmModalOpen(true);
    };
    const confirmDelete = (bookId: number) => {
        setSelectedBookId(bookId)
        setDeleteModalOpen(true);
    };
    useEffect(() => {
        dispatch(fetchHallBookById(Number(bookId)))

    }, [dispatch, bookId])
    return (
        <div>
            <div className="bg-gradient-to-r from-blue-600 to-indigo-500 text-white rounded-xl shadow-md p-6 mb-6">
                <h3 className='text-2xl font-semibold'>{t("book-details")}</h3>

            </div>
            <div className=' bg-white rounded-lg p-4 grid sm:grid-cols-2 xs:grid-cols-1 gap-5'>
                <div>
                    <h3 className='text-xl font-semibold mb-4'>{t("stay")}</h3>
                    <Link to={`/dashboard/place-details/${booking?.place?.id}`} className="flex w-full overflow-hidden rounded-2xl border shadow-sm bg-white" >
                        <div className="relative xs:w-32 sm:w-40 overflow-hidden">
                            <img
                                src={booking?.place?.images?.[0]?.url}
                                alt={booking?.place?.title}
                                className="w-full h-full object-cover"
                            />
                            <span
                                className={`absolute top-3 ${i18n.language === 'ar' ? 'right-3' : 'left-3'
                                    } rounded-md bg-primary px-3 py-1 text-xs sm:text-sm text-white`}
                            >
                                {booking?.place?.subCategory?.title || booking?.place?.type}
                            </span>
                        </div>
                        <div className="flex flex-col justify-between flex-1 p-3">
                            <div className="flex items-center justify-between">
                                <div className="flex items-center gap-2 text-sm text-gray-600">
                                    <FaStar className="text-secondry" />
                                    {booking?.place?.rate?.toFixed(1)}{' '}
                                    <span className="text-gray-400">
                                        ({booking?.place?.reviews?.length} {t('reviews')})
                                    </span>
                                </div>
                                <span
                                    className={`xs:text-xs sm:text-sm font-medium ${getStatusClass(
                                        booking?.state
                                    )}`}
                                >
                                    {booking?.state === "Pending" && booking.paymentMethod === "Cash" ? t("pending-cash") : t(`${booking?.state.toLowerCase()}`) || booking?.state}
                                </span>
                            </div>
                            <h2 className="mt-1 text-lg font-bold">
                                {booking?.place?.title}
                            </h2>
                            <p className="flex items-center gap-1 text-sm text-gray-500">
                                <CiLocationOn /> {booking?.place?.location}
                            </p>
                        </div>
                    </Link>
                    <section className="mt-10  w-full">
                        <h2 className="text-2xl font-semibold mb-4">{t("amenities")} </h2>
                        <div className="grid grid-cols-2 gap-4">

                            {booking?.place?.amenities.length === 0 && <div className=" text-textSecond">{t("no-services")}</div>}
                            {booking?.place?.amenities.map((amenity: any) => (
                                <div key={amenity.id} className="flex items-center gap-3  rounded-lg">
                                    <img src={amenity.image} alt={amenity.title} className="w-6 h-6" />
                                    <span className="text-sm text-nowrap text-gray-800">{amenity.title}</span>
                                </div>
                            ))}
                        </div>
                    </section>
                </div>
                <div>
                    <h3 className='text-xl font-semibold mb-4'>{t("booking")}</h3>
                    <div className=' flex flex-col justify-between h-full'>
                        <div>
                            <div className="flex-between pt-2 text-sm text-textSecond">
                                <p className="flex items-center gap-1 text-darkColor font-medium">
                                    <FaCalendarAlt />
                                    <span>{t('dates')}</span>
                                </p>
                                {(booking?.checkIn || booking?.bookDate) && <p>{booking.place.type === "Hall" ?
                                    <div>
                                        {booking.bookDate && new Date(booking.bookDate).toLocaleDateString("en-GB")}
                                        <p>{booking.duration === 1 ? t("morning-period") : t("afternoon-period")}</p>
                                    </div>
                                    : formatDateRange(booking?.checkIn, booking?.checkOut)}</p>}
                            </div>
                            {isHotel && (
                                <>
                                    <div className="flex justify-between pt-2 text-sm text-textSecond">
                                        <div className="flex items-center gap-1 text-darkColor font-medium">
                                            <FaBed />
                                            <p>{t('room-type')}</p>
                                        </div>
                                        <p>{booking.rooms[0].type}</p>
                                    </div>
                                    <div className="flex justify-between pt-2 text-sm text-textSecond">
                                        <div className="flex items-center gap-1 text-darkColor font-medium">
                                            <MdOutlineNumbers />
                                            <p>{t('room-number')}</p>
                                        </div>
                                        <p>{booking.rooms?.[0]?.roomNumber}</p>
                                    </div>
                                </>
                            )}
                            <div className="flex-between pt-2 text-sm text-textSecond">
                                <p className="flex items-center gap-1 text-darkColor font-medium">
                                    <IoPricetagsOutline />
                                    <span>{t('price')}</span>
                                </p>
                                <p className={` font-medium`}  >
                                    {booking?.price.toFixed(2)} {booking?.place.currencyCode}
                                </p>
                            </div>
                            <div className="flex-between pt-2 text-sm text-textSecond">
                                <p className="flex items-center gap-1 text-darkColor font-medium">
                                    <MdOutlinePayments />
                                    <span>{t('paymentMethod')}</span>
                                </p>
                                <p className={` font-medium`}  >
                                    {t(`${booking?.paymentMethod}`)}
                                </p>
                            </div>
                            <div className="flex-between pt-2 text-sm text-textSecond">
                                <p className="flex items-center gap-1 text-darkColor font-medium">
                                    <GrStatusUnknown />
                                    <span>{t('Status')}</span>
                                </p>
                                <p className={` font-medium ${getStatusClass(booking?.state)}`}  >
                                    {booking?.state === "Pending" && booking.paymentMethod === "Cash" ? t("pending-cash") : t(`${booking?.state.toLowerCase()}`) || booking?.state}
                                </p>
                            </div>
                            {booking?.state === "Waiting" && (
                                <div className='mt-4 text-sm flex gap-2 font-medium flex-row'>
                                    <button
                                        className="text-white bg-red-600 hover:bg-red-700 rounded-lg w-full py-2 px-4 transition"
                                        onClick={() => {
                                            confirmDelete(Number(booking?.id))
                                        }}
                                    >
                                        {t("refuse")}
                                    </button>
                                    <button
                                        className=" bg-primary hover:bg-[#00470f] w-full text-white py-2 px-4 rounded-lg transition"
                                        onClick={() => {
                                            confirm(Number(booking?.id))
                                        }}
                                    >
                                        {t("accept")}
                                    </button>
                                </div>
                            )}
                            {booking?.state === "Pre-Return" && (
                                <div className='mt-4 text-sm flex font-medium'>
                                    <button
                                        className="text-white bg-secondry hover:bg-[#bb5d00] rounded-lg w-full py-2 px-4 transition"
                                        onClick={() => {
                                            dispatch(refundHallBook({ userId: booking.userId, bookId: booking.id }))
                                        }}
                                    >
                                        {t("refunded")}
                                    </button>

                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <ConfirmModal
                    isOpen={confirmModalOpen}
                    onClose={() => setConfirmModalOpen(false)}
                    onConfirm={handleConfirm}
                    messageKey="accept-booking-confirm"
                />
                <ConfirmDeleteModal
                    isOpen={deleteModalOpen}
                    onClose={() => setDeleteModalOpen(false)}
                    onConfirm={handleRefuse}
                    messageKey="refuse-booking-confirm"
                />
            </div>
        </div>
    )
}

export default AdminHallBookDetails